import { render, staticRenderFns } from "./headType.vue?vue&type=template&id=0c45fdb7&scoped=true&"
import script from "./headType.vue?vue&type=script&lang=js&"
export * from "./headType.vue?vue&type=script&lang=js&"
import style0 from "./headType.vue?vue&type=style&index=0&id=0c45fdb7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45fdb7",
  null
  
)

export default component.exports